import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback, useLayoutEffect, useState } from 'react';
import DefaultSide from "./components/DefaultSide";
import RewardRightSide from "./components/RewardRightSide";
import { PlayroomRewardIndicatorTooltip } from "./ui";
import { jsx as _jsx } from "react/jsx-runtime";
export var PlayroomRewardIndicatorWithRive = function PlayroomRewardIndicatorWithRive(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCoinAnimationPlaying = _useState2[0],
    setIsCoinAnimationPlaying = _useState2[1];
  var changeCoinAnimationState = useCallback(function (runAnimation) {
    return function () {
      if (isCoinAnimationPlaying === runAnimation) return;
      setIsCoinAnimationPlaying(runAnimation);
    };
  }, [isCoinAnimationPlaying]);
  useLayoutEffect(function () {
    if (props.isCoinAnimationPlaying !== undefined) {
      setIsCoinAnimationPlaying(props.isCoinAnimationPlaying);
    }
  }, [props.isCoinAnimationPlaying]);
  return /*#__PURE__*/_jsx(PlayroomRewardIndicatorTooltip, {
    tooltip: props.tooltip,
    position: props.tooltipPosition,
    children: props.rewardName ? /*#__PURE__*/_jsx(RewardRightSide, _objectSpread(_objectSpread({}, props), {}, {
      isPlaying: isCoinAnimationPlaying,
      onMouseEnter: changeCoinAnimationState(true),
      onMouseLeave: changeCoinAnimationState(false)
    })) : /*#__PURE__*/_jsx(DefaultSide, _objectSpread(_objectSpread({}, props), {}, {
      isPlaying: isCoinAnimationPlaying,
      onMouseEnter: changeCoinAnimationState(true),
      onMouseLeave: changeCoinAnimationState(false)
    }))
  });
};
PlayroomRewardIndicatorWithRive.displayName = 'PlayroomRewardIndicatorWithRive';
export default PlayroomRewardIndicatorWithRive;